import HCLTreeVertex from "../../../HCLTreeVertex";
import {mxShape} from "mxgraph-js"; // refer to the type

class ATLEASTGateVertexShape extends mxShape {

  paintVertexShape(c: any, x: any, y: any, w: any, h: any): void {
    const gateSize = h * 0.28;
    const halfSize = gateSize / 2;
    c.translate(x, y);
    c.begin();
    c.moveTo(w * 0.5 - halfSize, h - gateSize);
    c.lineTo(w * 0.5 + halfSize, h - gateSize);
    c.lineTo(w * 0.5 + halfSize, h);
    c.lineTo(w * 0.5 - halfSize, h);
    c.close();
    c.fillAndStroke();
    const radius = HCLTreeVertex.SHAPE.RADIUS;
    c.roundrect(0, 0, w, h - gateSize, radius, radius);
    c.fillAndStroke();
  }

}

export default ATLEASTGateVertexShape;
